import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { Helmet } from "react-helmet-async";
import PremiumHeader from "components/PremiumLanding/PremiumHeader";
import HeroSection from "components/PremiumLanding/HeroSection";
import QuickBooking from "components/PremiumLanding/QuickBooking";
import ServicesSection from "components/PremiumLanding/ServicesSection";
import HowItWorks from "components/PremiumLanding/HowItWorks";
import FinalCTA from "components/PremiumLanding/FinalCTA";
import PremiumFooter from "components/PremiumLanding/PremiumFooter";
import "components/PremiumLanding/PremiumLanding.css";

export const LANDING_TEMPLATE = {
  id: "premium-logistics",
  name: "Premium Logistics"
};

export default function LandingPage() {
  const auth = useSelector((state) => state.auth);
  const settings = useSelector((state) => state.settingsdata.settings) || {};

  useEffect(() => {
    const elements = Array.from(document.querySelectorAll(".pl-reveal"));
    if (!elements.length) return undefined;

    if (!window.IntersectionObserver || window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      elements.forEach((element) => element.classList.add("is-visible"));
      return undefined;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });

    elements.forEach((element) => observer.observe(element));
    return () => observer.disconnect();
  }, []);

  return (
    <div className="premium-landing" data-landing-template={LANDING_TEMPLATE.id}>
      <Helmet>
        <title>Garahex | Move. Connect. Deliver.</title>
        <meta
          name="description"
          content="Book trusted domestic, container, port, yard and special cargo logistics services across the Philippines with Garahex."
        />
      </Helmet>
      <a className="pl-skip-link" href="#pl-main-content">Skip to content</a>
      <PremiumHeader isLoggedIn={Boolean(auth && auth.profile && auth.profile.uid)} />
      <main id="pl-main-content">
        <HeroSection />
        <QuickBooking />
        <ServicesSection />
        <HowItWorks />
        <FinalCTA />
      </main>
      <PremiumFooter settings={settings} />
    </div>
  );
}
